import type { ComponentPropsWithoutRef, ReactNode, Ref } from 'react'
import type { VariantProps } from 'tailwind-variants'

import { cn } from '@gto/ui/cn'

import { groupedFieldVariants } from './grouped-field.styles'

type GroupedFieldVariants = VariantProps<typeof groupedFieldVariants>

export type GroupedFieldControlsProps = ComponentPropsWithoutRef<'div'> &
  Pick<GroupedFieldVariants, 'gap' | 'orientation'> & {
    /** Wrapped controls, usually inputs or selects. */
    children?: ReactNode
    /** Additional CSS class names. */
    className?: string
    /** React 19 ref prop. */
    ref?: Ref<HTMLDivElement>
  }

export const Controls = ({
  children,
  className,
  gap,
  orientation,
  ref,
  ...props
}: GroupedFieldControlsProps) => {
  const { controls } = groupedFieldVariants({ gap, orientation })

  return (
    <div
      ref={ref}
      className={cn(controls(), className)}
      {...props}
    >
      {children}
    </div>
  )
}
